export type SubscriptionPlansDateRange = {
    start: Date | string | null;
    end: Date | string | null;
};

export interface SubscriptionPlansFilterForm {
    proId: string;
    status: string;
    partnerName: string;
    createdAt: SubscriptionPlansDateRange;
    commitmentStartDate: SubscriptionPlansDateRange;
    commitmentEndDate: SubscriptionPlansDateRange;
}

export const defaultSubscriptionPlansFilters: SubscriptionPlansFilterForm = {
    proId: '',
    status: '',
    partnerName: '',
    createdAt: {
        start: null,
        end: null,
    },
    commitmentStartDate: {
        start: null,
        end: null,
    },
    commitmentEndDate: {
        start: null,
        end: null,
    },
};

export const subscriptionPlansFilterLabels: Record<keyof SubscriptionPlansFilterForm, string> = {
    proId: 'Compte Pro',
    status: 'Statut',
    partnerName: 'Partenaire',
    createdAt: 'Date de création',
    commitmentStartDate: "Début d'engagement",
    commitmentEndDate: "Fin d'engagement",
};
